import { Transition, Dialog } from "@headlessui/react"
import { DeleteImv } from "../../../../services/DeleteImv"
import { Fragment } from "react"

export const ImvDeleteConfirmModal = ({ isOpen, onClose, nreg }) => {

    const handleDeleteConfirmed = async () => {

        try {
            const response = await DeleteImv(nreg)

            if (response.status === 200) {
                console.log('Imovel deletado com sucesso: ', response.data)
                onClose()
                window.alert(`Imovel ${nreg} deletado!`)
            }

        } catch (error) {
            console.error('Erro ao deletar imovel: ', error);
        }
    }

    return (
        <Transition appear show={isOpen}>
            <Dialog as='div' className='relative z-20' onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-[#0004] backdrop-blur" />
                </Transition.Child>
                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="xl:w-1/3 max-md:w-full transform border shadow-[inset_0_0_2rem_#fff2] overflow-hidden rounded-2xl bg-[#5a83d469] backdrop-blur-lg text-white p-6 text-left align-middle transition-all">
                                <Dialog.Title as="h3" className="text-lg mb-5 text-center font-medium leading-6 text-white">
                                    Deletar Imovel {`Nº${nreg}?`}
                                </Dialog.Title>
                                <h3 className="text-center"> Voce realmente deseja deletar este imovel? </h3>
                                <div className="flex items-center justify-evenly min-h-[7rem] [&>*]:border [&>*]:p-5 [&>*]:px-8 ">
                                    <button onClick={() => handleDeleteConfirmed()} className="bg-[#f14747] rounded-lg border-red-300 active:bg-[#e67070] transition duration-500"> Sim </button>
                                    <button onClick={() => onClose()} className="bg-[#707070] rounded-lg border-slate-300 active:bg-[#979797] transition"> Não </button>
                                </div>

                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}